<script setup>
import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useAccount } from 'dashboard/composables/useAccount';
import { frontendURL } from 'dashboard/helper/URLHelper';

const props = defineProps({
  item: {
    type: Object,
    required: true,
  },
});

const router = useRouter();
const { accountId } = useAccount();

const patientName = computed(() => props.item.contact?.name || '');
const phoneNumber = computed(() => props.item.contact?.phone_number || '');

const formattedValue = computed(() => {
  if (!props.item.estimated_value) return '';
  return Number(props.item.estimated_value).toLocaleString('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  });
});

const openConversation = () => {
  const displayId = props.item.conversation?.display_id;
  if (!displayId) return;
  router.push(
    frontendURL(`accounts/${accountId.value}/conversations/${displayId}`)
  );
};
</script>

<template>
  <div
    class="flex flex-col gap-1 p-3 transition-shadow duration-150 bg-white border rounded-lg shadow-sm cursor-grab select-none dark:bg-n-solid-2 border-n-weak hover:shadow-md active:cursor-grabbing"
  >
    <div class="flex items-center justify-between gap-2">
      <span class="text-sm font-medium truncate text-n-slate-12">
        {{ patientName || $t('PIPELINE.CARD.NO_NAME') }}
      </span>
      <span
        v-if="formattedValue"
        class="text-xs font-semibold whitespace-nowrap text-n-teal-11"
      >
        {{ formattedValue }}
      </span>
    </div>
    <span v-if="phoneNumber" class="text-xs text-n-slate-11">
      {{ phoneNumber }}
    </span>
    <button
      v-if="item.conversation"
      class="flex items-center gap-1 mt-1 text-xs text-left text-n-blue-11 hover:underline"
      @click.stop="openConversation"
    >
      <span class="i-lucide-message-circle size-3" />
      {{ $t('PIPELINE.CARD.OPEN_CONVERSATION') }} #{{
        item.conversation.display_id
      }}
    </button>
  </div>
</template>
